import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["placement", "distance", "zIndexOffset", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import styled from 'styled-components';
import Box from 'components/Box';
import useIsElementInView from 'hooks/useIsElementInView';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var Wrapper = styled(Box).withConfig({
  displayName: "StickyBox__Wrapper",
  componentId: "sc-lmwvzu-0"
})(["position:sticky;transition:box-shadow 250ms ease;"]);
/**
 * This component is a wrapper around the `Box` component that comes
 * with `position: sticky` styles to make it stick to either the
 * top or bottom edge of the browser.
 * It uses a nested one-pixel sized element to detect whether the
 * box is currently "stuck" to a side of the nearest scrollable parent
 * element, and if so, displays a drop-shadow to indicate that there's
 * more content below/above.
 */

function StickyBox(_ref) {
  var _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    _ref$distance = _ref.distance,
    distance = _ref$distance === void 0 ? 0 : _ref$distance,
    _ref$zIndexOffset = _ref.zIndexOffset,
    zIndexOffset = _ref$zIndexOffset === void 0 ? 0 : _ref$zIndexOffset,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useIsElementInView = useIsElementInView({
      initialValue: true
    }),
    isInView = _useIsElementInView.isInView,
    watchedElementRef = _useIsElementInView.watchedElementRef;
  var isSticky = !isInView;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [placement === 'top' && /*#__PURE__*/_jsx(Box, {
      ref: watchedElementRef,
      position: "absolute",
      top: -distance,
      width: "1px",
      height: "1px"
    }), /*#__PURE__*/_jsx(Wrapper, _objectSpread(_objectSpread({
      background: "background"
    }, otherProps), {}, {
      bottom: placement === 'bottom' ? distance : undefined,
      top: placement === 'top' ? distance : undefined,
      z: function z(theme) {
        return theme.globals.z.raised + 5 + zIndexOffset;
      },
      boxShadow: isSticky ? "".concat(placement, "Fold") : undefined,
      children: children
    })), placement === 'bottom' && /*#__PURE__*/_jsx(Box, {
      ref: watchedElementRef,
      position: "relative",
      bottom: -distance,
      width: "1px",
      height: "1px",
      mt: -1
    })]
  });
}
export default StickyBox;